import React from 'react';
import { Button, Dropdown } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { changeLanguage, useTranslation } from '../i18n';
import { LANGUAGE_OPTIONS, normalizeLanguage, type AppLanguage } from '../i18n/languages';

type LanguageSwitcherProps = {
  className?: string;
};

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const current = normalizeLanguage(i18n.language);
  const currentLabel = LANGUAGE_OPTIONS.find((o) => o.value === current)?.label;

  return (
    <Dropdown
      trigger={['click']}
      placement='bottomRight'
      menu={{
        selectable: true,
        selectedKeys: [current],
        items: LANGUAGE_OPTIONS.map((o) => ({ key: o.value, label: o.label })),
        onClick: ({ key }) => changeLanguage(key as AppLanguage)
      }}
    >
      <Button
        type='text'
        icon={<GlobalOutlined />}
        className={['lang-switcher', className].filter(Boolean).join(' ')}
      >
        {currentLabel}
      </Button>
    </Dropdown>
  );
}

export default LanguageSwitcher;
